import {
  Component,

  OnInit,
  OnDestroy,
  HostListener,
  Inject,
} from '@angular/core';
import { environment } from '../environments/environment';
// Aliased: this app's own `Location` model (a receiving facility) is the Location
// meant everywhere else in the codebase, so the Angular one is named for what it
// does here — turn an app route into a URL that carries the deployment's base href.
import { Location as AngularLocation } from '@angular/common';
import { Platform } from '@ionic/angular';

import {
  MsalService,
  MsalBroadcastService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';

import { from, Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { addIcons } from 'ionicons';
import {print, person, create, createOutline, scan, folderOpenOutline, folderOpen, imagesOutline, camera, cameraOutline, barcode, logOutOutline, logInOutline,
   swapVertical, funnel, personAdd, open, close, checkmark, mail, closeCircle,
   starOutline, star, help, documentTextOutline, warning, trash, trashOutline, cloudUploadOutline, copyOutline,
   chevronForwardOutline, chevronBackOutline, ellipsisVertical, copy, send,
   personCircleOutline,
   checkmarkCircle, checkmarkOutline, checkmarkCircleOutline,
   sparklesOutline, imageOutline, closeOutline, addOutline, arrowForwardOutline, chevronExpandOutline, chevronDownOutline,
   printOutline, navigateOutline, backspaceOutline, removeOutline, closeCircleOutline,
   informationCircleOutline, alertCircleOutline, cogOutline, constructOutline, gitBranchOutline, removeCircleOutline, handLeftOutline,
   expandOutline, eyeOutline, mailOutline,
   scanOutline, refreshOutline, keypadOutline, textOutline, chevronUpOutline,returnUpBackOutline,
   calendarOutline, downloadOutline, gridOutline, clipboardOutline, timeOutline, checkmarkDoneOutline,arrowForwardCircleOutline, arrowForwardCircle,swapHorizontalOutline,homeOutline,optionsOutline,
   menuOutline, warningOutline,
   addCircleOutline,
   flaskOutline,
   ellipseOutline, buildOutline, image} from 'ionicons/icons';
  
import { AppPage } from './models/assets-data/AppSetttings.interface';
import { SelectedLocation } from './models/selectedLocation.interface';

import { ReceivingLogStateService } from './domain/receiving-log/receiving-log-state.service';
import { isNewLogMenuRoute, SHARED_FLOW_ROUTE } from './domain/receiving-log/rules/new-log-route.rules';
import { ContactsService } from './service/contact.service';
import { AssetsDataService } from './service/assets-data.service';
import { ScreenSizeService } from './service/screen-size.service';
import { SelectedLocationService } from './service/selected-location.service';
import { EntraService } from './service/entra.service';
import { filter, take } from 'rxjs/operators';
import { TestService } from './service/test.service';
import { PwaUpdateService } from './service/pwa-update.service';
import { PwaService } from './service/pwa.service';
import { ProductionMovePromptService } from './service/production-move-prompt.service';
import { ConnectivityService } from './service/connectivity.service';
import { PrintFallbackService } from './service/print-fallback.service';
import { SubmitFailureNotifierService } from './service/receiving-mobile/submit-failure-notifier.service';
import { User } from './models/User.interface';



/**
 *   Main component for the ReceivingMgr app, responsible for managing:
  - User authentication and login/logout flow via EntraService.
  - Dynamic page titles based on route and configuration from AssetsDataService.
  - Location management and display of location-specific information.
  - Screen size adjustments for responsive design.
  - Fetching app configurations like app name, pages, icons, and more from AssetsDataService.
  - Event-driven updates with Behavioral Subjects for user login status, username, location, and screen size.

  Subscribes to various observables like login status, username, screen size, and others.
 */


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit, OnDestroy {
  //Subscriptions to behavioral subjects controlled in the EntraService,ReceivingLogStateService, and ScreenSizeService:
  //--------------------------------------------------
  private loginSubscription!: Subscription;
  private userSubscription!: Subscription;
  private printFallbackSubscription!: Subscription;
  public screenSizeSubscription!: Subscription;
    //--------------------------------------------------

  public appVersion = environment.version;
  public assetsVersion = environment.assetsVersion;
  public platform!: Platform;
  public isMobile: boolean=false;
  public loggedIn: boolean | undefined = false;
  public userName!: string;

  public tokenExpiration: string = '';

  private _router: Router;


  public locationsRecord!: Record<string,string>;
  public isLargeScreen!: boolean;
  public isSmallScreen!: boolean;
  public isDevMode = environment.dev;

  public appName: string = 'ReceivingMgr';
  public appPages!: AppPage[];
  public routeTitles!: Record<string, string>;

  public selectedIndex!: number;

  public pageTitle = '';

  /**
   * True on a route that renders its own frame instead of the app shell (today
   * only the public /install-help page). The shell's header and menu are built
   * around a signed-in user — location selector, menu, login state — so a page
   * meant to be readable before login draws its own header and this hides ours.
   */
  public isStandalonePage = false;

  /** Whether the shared install-instructions modal is presented (from the toast). */
  public showInstallHelp = false;

  /** Whether the printer-status (print fallback) modal is presented, from the menu. */
  public showPrinterStatus = false;

  /**
   * Whether this device is currently routing printing around a dead printer —
   * badges the menu's Printing row. The banner says what is happening; this
   * is for someone who has the menu open on a route they scrolled past it on.
   */
  public printFallbackActive = false;

  /**
   * What the menu row says under "Printing" while an outage override is on.
   *
   * A bare "On" badge used to sit here, and it answered nothing: printing is a
   * feature that is always on, so "on" left the reader to guess whether it meant
   * enabled, rerouted, or broken. This says which document moved instead — the
   * one thing someone opening this menu mid-shift actually needs.
   */
  public printFallbackSummary = '';

  public selectedLocationName!: string;
  private _receivingLogService:ReceivingLogStateService;

  private _selectedLocationService: SelectedLocationService;
  private _assetsDataService: AssetsDataService;
  private _screenSizeService: ScreenSizeService;
  private _entraService: EntraService;
  private _testService: TestService;
  private _contactsService: ContactsService;
  private _pwaUpdateService: PwaUpdateService;
  public timestamp!: number;

  constructor(
    @Inject(MSAL_GUARD_CONFIG) msalGuardConfig: MsalGuardConfiguration,
    msalService: MsalService,
    msalBroadcastService: MsalBroadcastService,
    router: Router,
   receivingLogService:ReceivingLogStateService,
    contactsService: ContactsService,
    assetsDataService: AssetsDataService,
    screenSizeService: ScreenSizeService,
    entraService: EntraService,
    testService: TestService,
    pwaUpdateService: PwaUpdateService,
    private _submitFailureNotifier: SubmitFailureNotifierService,
    private _location: AngularLocation,
    private _pwaService: PwaService,
    private _productionMovePrompt: ProductionMovePromptService,
    private _connectivityService: ConnectivityService,
    private _printFallbackService: PrintFallbackService,

    platform: Platform,
    selectedLocationService: SelectedLocationService
  ) {
// These icons are also added dynamically in the loadIcons() method, allowing additional icons to be configured via the app-settings.json file 
// without requiring manual imports here. However, to ensure that essential icons are always available—especially since some icons may not load 
// properly until the app has been interacted with extensively—we pre-load them here. This approach guarantees immediate availability while 
// still maintaining the flexibility to add more icons dynamically if needed.

    addIcons({print, person, personCircleOutline, create, createOutline, scan, folderOpenOutline, folderOpen, imagesOutline, camera, cameraOutline, barcode, logOutOutline, logInOutline,
      swapVertical, funnel, personAdd, open, close, checkmark, mail, closeCircle, starOutline, star, help,
      documentTextOutline, warning, trash, trashOutline, cloudUploadOutline, copyOutline,
      chevronBackOutline, chevronForwardOutline, ellipsisVertical, send,
      checkmarkCircle, checkmarkOutline, checkmarkCircleOutline,
      sparklesOutline, imageOutline, closeOutline, addOutline, arrowForwardOutline,
      printOutline, navigateOutline, backspaceOutline, removeOutline, closeCircleOutline,
      informationCircleOutline, alertCircleOutline, cogOutline, constructOutline, gitBranchOutline, removeCircleOutline,chevronExpandOutline, chevronDownOutline,
      expandOutline, eyeOutline, mailOutline, calendarOutline, handLeftOutline,
      scanOutline, refreshOutline, keypadOutline, textOutline, chevronUpOutline, returnUpBackOutline, menuOutline, checkmarkDoneOutline,
      downloadOutline, buildOutline, image,  gridOutline, clipboardOutline, timeOutline,  addCircleOutline, arrowForwardCircleOutline, arrowForwardCircle, flaskOutline, swapHorizontalOutline, homeOutline, ellipseOutline, optionsOutline, warningOutline,
    });
    this._entraService = entraService;
    this._router = router;
    this._receivingLogService =receivingLogService;

    this._assetsDataService = assetsDataService;
    this._screenSizeService = screenSizeService;
    this._testService = testService;
    this._contactsService = contactsService;
    this._pwaUpdateService = pwaUpdateService;
    this._selectedLocationService = selectedLocationService;
    this.platform = platform;
    
    this.checkScreenSize(); // Check screen size on load. This will inform app layout.
    this.configureAssetsData(); // Load app configuration data from AssetsDataService.

    this.setMobileState(); // Set the mobile state and initialize Eruda on mobile devices in dev/uat builds
  

  }

  

/**
 * ngOnInit
 * Initializes the component:
 * - Sets up routing event listeners for navigation changes.
 * - Sets up subscriptions for login status, username, and screen size.
 * - Loads location information from localStorage or defaults to 'norfolk'.
 * 
 */
  ngOnInit(): void {

    // Read the shell's visibility off the address bar before the router has
    // resolved anything. On a cold load of /install-help the first NavigationEnd
    // arrives after this component renders, so waiting for it would flash the
    // app header at a visitor who is not signed in.
    this.isStandalonePage = this.isStandaloneRoute(window.location.pathname);

    // Listen for route changes and update the page title accordingly
    this._router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const currentUrl = this._router.url;
        this.setTitle(currentUrl);
        this.isStandalonePage = this.isStandaloneRoute(currentUrl);
      });

// Set up subscriptions for login status, username, and screen size
    this.setSubscriptions();

    // Start watching for new PWA builds and prompt the user to reload when one
    // is ready. No-ops when the service worker is disabled (e.g. local dev).
    this._pwaUpdateService.initialize();

    // Surface any async-submit background-job permanent failure as a toast with a
    // one-tap Retry, wherever the user is (the Done screen still shows its own banner).
    this._submitFailureNotifier.init();

    // Start watching for connectivity loss, which the shell's <app-offline-banner>
    // renders. Called from here rather than the constructor so the window
    // listeners are registered inside Angular's zone — see ConnectivityService.
    this._connectivityService.init();

    // Warm the employee-email list once per app session. Safe to call this early
    // because ensureCompanyEmails() parks until Entra reports a signed-in user —
    // an unguarded fetch here goes out before MSAL has an active account, comes
    // back empty, and every page ends up refetching. Pages call the same method,
    // so once this lands they all read the cache.
    // The service toasts the failure itself; this handler just keeps a failed
    // fetch from surfacing as an unhandled rejection.
    this._contactsService.ensureCompanyEmails().subscribe({
      error: (err) => console.error('Employee directory prefetch failed:', err),
    });

    //Set the timestamp for the app
    this.timestamp = Date.now();

    // Fetch the locations data
    this.loadLocations();


     


    // Check if a location is stored in localStorage. If not, default to 'norfolk'
    //Then build the selected location object and emit it to thereceivingLogService, where it will be used by other components.
    //The selectedLocationName is passed to the location dropdown component for display.
    const storedLocationName = localStorage.getItem('selectedLocationName');
    if (storedLocationName) {
      this.selectedLocationName = storedLocationName;
      const selectedLocation = this.buildSelectedLocation(storedLocationName);
      this._selectedLocationService.setSelectedLocation(selectedLocation);
    } else {
      const locationName = 'kent';
      this.selectedLocationName = locationName;
      const selectedLocation = this.buildSelectedLocation(locationName);
      this._selectedLocationService.setSelectedLocation(selectedLocation);
    }

    // Offer the install instructions to someone on a phone who could act on them.
    this.maybeOfferInstall();

    // On the pilot deployment, point the user at the real site now that the
    // mobile flow has shipped there. No-ops everywhere else, production
    // included — see ProductionMovePromptService.
    this._productionMovePrompt.init();

    this._testService.testEndpoint();
  }

  /**
 * maybeOfferInstall
 * Shows the one-time "add to your home screen" toast, if this browser could
 * actually install the app (see {@link PwaService.shouldPromptToInstall}).
 *
 * Only while signed OUT, and only on the landing page. Both conditions are the
 * point rather than caution:
 *  - Installing before signing in is the right order — the installed app is a
 *    separate browser context, so anyone who signs in first signs in twice. The
 *    instructions say as much in step 1.
 *  - Signed-in users reach the same instructions from the menu's Help section,
 *    and a toast has no business covering the mobile flow's bottom actions while
 *    someone is logging a delivery.
 * It also keeps the flags honest: login() and logout() both clear localStorage,
 * so a "don't show again" written after signing in would not survive anyway.
 *
 * Deferred a couple of seconds so it lands after the app settles rather than
 * during boot, an MSAL redirect, or PwaUpdateService's update alert.
 */
  private maybeOfferInstall(): void {
    setTimeout(() => {
      const onLandingPage = this._router.url.split('?')[0] === '/';
      if (this.loggedIn || !onLandingPage || !this._pwaService.shouldPromptToInstall()) {
        return;
      }

      void this._pwaService.presentInstallPrompt(() => {
        this.showInstallHelp = true;
      });
    }, 2500);
  }


  /**
 * ngOnDestroy
 * Cleans up all active subscriptions to prevent memory leaks.
 * - Unsubscribes from login and user subscriptions.
 * - Cleans up screen size and MSAL (Entra) service subscriptions.
 */
  ngOnDestroy() {
    this.screenSizeSubscription.unsubscribe();
    this._entraService.msalInstanceNgOnDestroy();
    this.loginSubscription.unsubscribe();
    this.userSubscription.unsubscribe();
    this.printFallbackSubscription?.unsubscribe();
  }


  /**
 * loadLocations
 * Fetches the locations record from the AssetsDataService and stores it in `locationsRecord`.
 * - locationsRecord is passed to the location dropdown component for display.
 */
  public loadLocations(): void {
    const locationsRecord = this._assetsDataService.GetLocationsRecord();
    this.locationsRecord = locationsRecord;
  }

  /**
   * setMobileState
   * Sets the mobile state and initializes Eruda on mobile devices in dev/uat builds.
   */
  public setMobileState(): void {
    const isMobile = this.platform.is('ios') || this.platform.is('android');
    this.isMobile = isMobile;
    this._screenSizeService.isMobile.next(isMobile);

        // Initialize the Eruda mobile inspector only on dev/uat builds — the
        // floating gear icon must never appear in production.
        if (this.isMobile && (environment.dev || environment.uat)) {
          const script = document.createElement('script');
          script.src = '//cdn.jsdelivr.net/npm/eruda';
          document.body.appendChild(script);
          script.onload = () => {
            (window as any).eruda.init();
          };
        }
  }


  /**
 * buildSelectedLocation method is called in ngOnInit and within onLocationChange:
 * Constructs a `SelectedLocation` object from the provided location name.
 * @param locationName - The name of the location to retrieve data for.
 * @returns The selected location object with name, label, and laydownSpaceAvailable status.
 */
  public buildSelectedLocation(locationName:string): SelectedLocation {
    const locationLabel = this.locationsRecord[locationName];
    const laydownAvailable: boolean = 
      this._assetsDataService.IsLaydownAvailableAtLocation(locationName);
    const selectedLocation: SelectedLocation = {
      name: locationName,
      label: locationLabel,
      laydownSpaceAvailable: laydownAvailable
    };
    return selectedLocation;
  }


/**
 * configureAssetsData method is called in ngOnInit:
 * Fetches and configures app data, such as app name, pages, and route titles.
 * - Retrieves app configuration from AssetsDataService.
 * - Sets up routing titles for dynamic page titles based on URL.
 * - Loads icons dynamically using the loadIcons() method.
 */
  public configureAssetsData(){
    this.appName = this._assetsDataService.GetAppName();
    const appPages = this._assetsDataService.GetAppPagesData();
    this.appPages= appPages;
    let routeTitles: Record<string, string> = {};
    appPages.forEach((page) => 
    routeTitles[page.url] = page.pageTitle);
    this.routeTitles = routeTitles;
    this.loadIcons();
  }


  /**
 * loadIcons
 * Dynamically loads icons for the app based on configuration from AssetsDataService.
 * - Uses dynamic imports to load ionicons icons and adds them for use in the app.
 */
  async loadIcons() {
    // Iterate through each page and import the icon dynamically
    const iconNames = this._assetsDataService.GetAppIconsData();

    // Define the type of iconImports: it should have string keys and string values
    let iconImports: Record<string, string> = {};

    // Dynamically import the icons module
    const icons = await import('ionicons/icons');

    // Iterate over the list of icon names and import the corresponding icon dynamically
    for (const iconName of iconNames) {
      // Access the icon dynamically using the icon name
      const icon = icons[iconName as keyof typeof icons];

      // Type assertion to tell TypeScript that the icon is definitely a string
      if (typeof icon === 'string') {
        iconImports[iconName] = icon;
      } else if (typeof icon === 'object' && 'default' in icon) {
        // If the icon is an object with a 'default' property, access it
        iconImports[iconName] = icon.default as string;
      } else {
        console.error(`Failed to load icon: ${iconName}`);
      }
    }

    // Assuming addIcons expects an object with icon names as keys and string values (icon paths)
    addIcons(iconImports);
  }

/**
 * setSubscriptions method is called in ngOnInit:
 * Sets up subscriptions for login status, username, and screen size.
 * - Observes login status changes and updates the `loggedIn` property.
 * - Observes username changes and updates the `userName` property.
 * - Observes screen size changes and updates screen size properties.
 */
  private setSubscriptions(): void {
    this.loginSubscription = this._entraService.userIsLoggedIn.subscribe(
      (loggedIn: boolean) => {
        this.loggedIn = loggedIn;
      }
    );

    this.userSubscription = this._entraService.user.subscribe(
      (user: User) => {
        this.userName = user.name;
      }
    );

    // Badge the menu's Printing row while an outage override is active. Only an
    // override — a location whose standing configuration prints from the browser
    // is not in an outage and must not be badged as one.
    this.printFallbackSubscription = this._printFallbackService.mode$.subscribe(
      (mode) => {
        this.printFallbackActive = mode !== 'normal';
        this.printFallbackSummary =
          mode === 'printApiDown' ? 'Labels + copier sheets: desktop only'
          : mode === 'zebraDown' ? 'Labels: desktop only'
          : mode === 'copierDown' ? 'Copier sheets: desktop only'
          : '';
      }
    );

    // Listen for screen size changes
    if (this.screenSizeSubscription) {
      this.screenSizeSubscription.unsubscribe();
    }
    this.screenSizeSubscription =
      this._screenSizeService.isLargeScreen.subscribe((isLargeScreen) => {
        this.isLargeScreen = isLargeScreen;
      });
  }


  /**
 * setTitle
 * Sets the page title based on the current route.
 * @param url - The current route URL to match against predefined route titles.
 */
  private setTitle(url: string): void {
    // Check if the URL matches one of our predefined routes
    const routeTitle = this.routeTitles[url];

    if (routeTitle) {
      this.pageTitle = routeTitle;
    }
  }

  /**
 * openInstallHelp
 * Opens the install instructions (/install-help) in a new browser tab from the
 * menu's Help section.
 *
 * A new tab rather than a route change for two reasons: the user keeps whatever
 * they were part-way through in this tab, and the instructions are something you
 * follow on a second device while reading — closing the tab puts them straight
 * back where they were. It is also the page's one honest use on desktop, where
 * you read the steps here and do them on a phone.
 *
 * The URL goes through Location.prepareExternalUrl so it picks up the
 * deployment's base href (the dev build serves under /receiving-manager/), which
 * a hardcoded '/install-help' would drop.
 *
 * Shown to every signed-in user, not gated on {@link PwaService}: this is a help
 * topic someone may open to walk a colleague through installing it, unlike the
 * landing page's install prompt, which is hidden once the app is installed.
 */
  public openInstallHelp(): void {
    const url = this._location.prepareExternalUrl('/install-help');
    // 'noopener': the new tab gets no window.opener handle back to this one.
    window.open(url, '_blank', 'noopener');
  }

  /**
 * isStandaloneRoute
 * Whether a URL belongs to a page that draws its own frame and so must not be
 * wrapped in the app shell (see {@link isStandalonePage}).
 *
 * Matched on a path segment rather than an exact string so it holds for both the
 * router's URL and window.location.pathname, which carries the deployment's base
 * href in front of the route.
 *
 * @param url - The router URL or window pathname to test.
 * @returns True when the URL is the public install-help page.
 */
  private isStandaloneRoute(url: string): boolean {
    return url.split('?')[0].split('/').includes('install-help');
  }

  /**
 * login method is called in the html file when the user clicks the login button:
 * Triggers the login process using EntraService.
 * - Clears any location or URL-related data stored in localStorage.
 * - Calls the login method from EntraService.
 * 
 *
 */
  public async login() {
    this.pageTitle = '';
    // The print-fallback mode is carried across the wipe: it describes the
    // hardware in this building, not the session. On a shared warehouse PC this
    // clear() runs daily, and silently routing the next shift's labels back to a
    // printer someone flagged as dead is the bug that guard exists for.
    this._printFallbackService.preserveThrough(() => localStorage.clear());
    this._entraService.login();
  }


  /**
 * logout method is called in the html file when the user clicks the logout button:
 * Triggers the logout process using EntraService.
 * - Clears any location or URL-related data stored in localStorage.
 * - Sets page title to "Logged Out".
 */
  public async logout() {
    this.pageTitle = 'Logged Out';
    // Preserved for the same reason as in login() — the printer is still broken
    // after the operator signs out.
    this._printFallbackService.preserveThrough(() => localStorage.clear());
    this._entraService.logout();
  }



  /**
 * onMenuClick
 * Handles menu item click, setting the selected index and page title.
 * @param title - The title of the page selected.
 * @param i - The index of the selected page.
 */
  public onMenuClick(title: string, i: number): void {
    this.selectedIndex = i;
    this.pageTitle = title;
    localStorage.setItem('lastUrl', this.resolveMenuUrl(this.appPages[i]));
  }

  /**
   * resolveMenuUrl
   * Resolves the route a menu item should open. "New Receiving Log Entry" always
   * opens the shared receiving flow, whatever app-settings.json names for it;
   * everything else uses its configured url as-is.
   */
  public resolveMenuUrl(page: AppPage): string {
    return isNewLogMenuRoute(page.url) ? SHARED_FLOW_ROUTE : page.url;
  }

/**
 * onLocationChange method is passed as an event handler to the location dropdown component:
 * Updates the selected location and emits it to the parent component via `selectedLocation`.
 * @param selectedValue - The location name that has been selected.
 */
  public onLocationChange(selectedValue: string): void {
    localStorage.setItem('selectedLocationName', selectedValue);

    this.selectedLocationName = selectedValue;
    const selectedLocation = this.buildSelectedLocation(selectedValue);

    // Emit event to parent component
    this._selectedLocationService.setSelectedLocation(selectedLocation);
  }


/**
 * onResize
 * Listens to window resize events to check and update the screen size.
 * - Updates the `isLargeScreen` and `isSmallScreen` flags.
 */
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }


/**
 * checkScreenSize method is called on window resize events and on component initialization:
 * Checks and updates the screen size status (large or small).
 * - Sets `isLargeScreen` and `isSmallScreen` properties based on the window width.
 */
  checkScreenSize() {
    const isLargeScreen = window.innerWidth > 1500;
    const isSmallScreen = window.innerWidth <= 768;
    this.isLargeScreen = isLargeScreen;
    this.isSmallScreen = isSmallScreen;
    this._screenSizeService.isLargeScreen.next(isLargeScreen);
    this._screenSizeService.isSmallScreen.next(isSmallScreen);
  }
}
